import React from 'react'
import { Modal, Input, Button, Row, Col } from 'antd'

import { withRouter, Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import moment from 'moment'
import Edit from './Edit'
import Show from './Show'

class Item extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleNew = this.handleNew.bind(this)
  }

  get administrators(){
    return this.props.administrators || {}
  }
  get current(){
    return this.props.appointmentTypes[this.props.match.params.id] || {};
  }

  handleNew(){
    this.props.history.push(`/admin/appointment-types/new`)
  }

  render() {
    return (
      <div className='edit-switch'>
        <Switch>
          <Route exact path='/admin/appointment-types/new' render={()=>
            <Edit current={this.current} type='new' />
          }/>
          <Route exact path='/admin/appointment-types/:id' render={()=>
            <Show current={this.current} />
          }/>
          <Route exact path='/admin/appointment-types/:id/edit' render={()=>
            <Edit current={this.current} type='edit' />
          }/>
        </Switch>
      </div>
    )
  }
}

export default withRouter(connect((state)=>(state))(Item))